
<div>
  <security-mask
    v-if="securityMaskingEnabled"
    :masked-values="securityMaskedValues"
    :class="commonEntriesPropertiesCssClasses"
    v-tooltip.wrap="tooltipText"
    v-bind="$attrs"
  ></security-mask>
  <input v-else type="text" :class="entriesPropertiesCssClasses" v-tooltip.wrap="tooltipText" disabled :value="localValue" @input="" v-bind="$attrs">
</div>
